import React from 'react'

export default function Oops(props) {
  return <div className="Oops">
      <h1>404</h1>
      <h2>OOPS! Page Not Found...</h2>
    </div>
}
